import customAppsActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  customApps: createAsyncRequestReducer(
    customAppsActionTypes.FETCH_CUSTOM_APPS,
  ),
};

export default combineReducers(reducers);
